import React, { useEffect, useState } from 'react';
import { KeyRound } from 'lucide-react';
import PasswordForm from './PasswordForm';

export default function CredentialsSection({ profile, onSetPassword, onChangePassword }) {
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const hasPassword = Boolean(profile?.has_password);

  useEffect(() => {
    setShowForm(false);
    setSuccess('');
  }, [hasPassword]);

  const handleSubmit = async ({ currentPassword, newPassword, confirmPassword }) => {
    setLoading(true);
    setSuccess('');
    try {
      if (hasPassword) {
        await onChangePassword({ currentPassword, newPassword, confirmPassword });
        setSuccess('Password changed successfully');
        setShowForm(false);
      } else {
        await onSetPassword({ newPassword, confirmPassword });
        setSuccess('Password set successfully');
        setShowForm(false);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="ga-card rounded-lg border border-ga-border-subtle/60 p-5">
      <div className="flex items-center gap-2 mb-4">
        <KeyRound className="h-4 w-4 text-ga-primary" aria-hidden="true" />
        <h2 className="text-sm font-semibold text-ga-text-primary">Sign-in credentials</h2>
      </div>

      <dl className="space-y-4 mb-5">
        <div>
          <dt className="text-xs font-medium text-ga-text-muted">Username</dt>
          <dd className="mt-0.5 text-sm text-ga-text-primary">{profile?.phone || profile?.username || '—'}</dd>
          <p className="mt-1 text-xs text-ga-text-muted">Your username is your phone number and cannot be changed.</p>
        </div>
        <div>
          <dt className="text-xs font-medium text-ga-text-muted">Password</dt>
          <dd className="mt-0.5 text-sm text-ga-text-primary">
            {hasPassword ? 'Password is set' : 'No password set'}
          </dd>
        </div>
      </dl>

      {success && (
        <p className="mb-4 text-sm text-emerald-600 dark:text-emerald-400" role="status">{success}</p>
      )}

      {!showForm && !hasPassword && (
        <button
          type="button"
          onClick={() => { setShowForm(true); setSuccess(''); }}
          className="inline-flex items-center justify-center rounded-lg bg-ga-primary px-4 py-2 text-sm font-medium text-white hover:bg-ga-primary/90 min-h-10"
        >
          Set password
        </button>
      )}

      {!showForm && hasPassword && (
        <button
          type="button"
          onClick={() => { setShowForm(true); setSuccess(''); }}
          className="inline-flex items-center justify-center rounded-lg border border-ga-border-subtle px-4 py-2 text-sm font-medium text-ga-text-primary hover:bg-ga-bg-page min-h-10"
        >
          Change password
        </button>
      )}

      {showForm && (
        <PasswordForm
          hasPassword={hasPassword}
          onSubmit={handleSubmit}
          loading={loading}
        />
      )}
    </section>
  );
}
